import Helpers from '..';

/**
 * Checks if last ad should be injected. Counts the words from the last element of
 * provided type (defaults to 'DESKTOP_INLINE_ADVERT') until the end of the injected
 * array. Returns true if that count is higher than the configuration
 * @param {Array} injectedArray Original graphQL body array injected with elements.
 * @param {Boolean} mobile True if rule should run for mobile.
 * @param {Object} adSettings Includes all the config for the rules.
 * @param {Array} typeToStartCount Array of elements - defaults to 'DESKTOP_INLINE_ADVERT'.
 * @returns {Boolean}
 */
const shouldInjectLastAd = ({
  injectedArray,
  mobile,
  props: { adSettings },
  typeToStartCount = 'DESKTOP_INLINE_ADVERT',
}) => {
  const {
    minNumOfWordsAfterLastInlineAdDesktop,
    minNumOfWordsAfterLastInlineAdMobile,
  } = adSettings;

  if (
    (!minNumOfWordsAfterLastInlineAdDesktop && minNumOfWordsAfterLastInlineAdDesktop !== 0)
    && (!minNumOfWordsAfterLastInlineAdMobile && minNumOfWordsAfterLastInlineAdMobile !== 0)
  ) return false;

  if (mobile) {
    return Helpers.getWordCountFromLastIndexOfTypeToEndOfArray(
      { injectedArray, typeToStartCount },
    ) >= minNumOfWordsAfterLastInlineAdMobile;
  }

  return Helpers.getWordCountFromLastIndexOfTypeToEndOfArray(
    { injectedArray, typeToStartCount },
  ) >= minNumOfWordsAfterLastInlineAdDesktop;
};

export default shouldInjectLastAd;
